import React, { useRef, useState, useEffect, useCallback } from 'react';
import { useSnapshot } from 'valtio';
import { Eye, EyeOff } from 'lucide-react';

import API from '../../lib/api';
import { state } from '../../store/global';
import findMessage from '../../utils/messages'; // Helper function defined below

export default function ProfileModal({ children }) {
  const snap = useSnapshot(state);

  return (
    <div className="relative">
      <div className="fixed z-50 inset-0 bg-black opacity-30 w-full h-full"></div>
      <div className="z-51 fixed inset-0 p-8"></div>

      <div className="z-51 fixed inset-0 flex items-center justify-center font-[poppins]">
        {children}
      </div>
    </div>
  );
}
